import { getBrowserLocation, shouldProxyThroughOrigin } from './index'
import type { BrowserLocation } from './index'

const RPC_PATH = /^\/creativefabrica\./

export function toProxyUrl(url: string, origin: string, prefix: string) {
  const { pathname, search } = new URL(url)
  if (!RPC_PATH.test(pathname)) {
    return url
  }
  return origin + pathname.replace(RPC_PATH, `/${prefix}.`) + search
}

export function rpcUrlForLocation(
  url: string,
  location: BrowserLocation | null,
  prefix = process.env.VITE_RPC_PREFIX,
) {
  if (!prefix) {
    return url
  }
  const backendHostname = new URL(url).hostname
  if (!shouldProxyThroughOrigin({ location, backendHostname })) {
    return url
  }
  if (!location) {
    return url
  }
  return toProxyUrl(url, location.origin, prefix)
}

export function rpcUrlForRequestHost(url: string, host: string | undefined) {
  if (!host) {
    return rpcUrlForLocation(url, null)
  }
  return rpcUrlForLocation(url, { hostname: host, origin: `https://${host}` })
}
